/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const LoanDetailPage = lazyLoad(
  () => import('./index'),
  module => module.LoanDetailPage,
);
